import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    headerTitleContainer: {
        position: "absolute",
        left: 0,
        right: 0
    },
    headerTitle: {
        alignSelf: "center"
    },
    filterItemContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    filterSeparator: {
        width: 1,
        height: 20
    },
    notFoundContainer: {
        alignItems: "center",
        justifyContent: "center"
    },
    notFoundText: {
        textAlign: "center"
    },
    loadingContainer: {
        alignItems: "center",
        justifyContent: "center"
    },
    filterText: {
        paddingHorizontal: 2
    }
});

export default stylesheet;
